import React from 'react';
import Header from '../Layout/Header';
import Footer from '../Layout/Footer';
import { Link } from 'react-router-dom';

const PrivacyPolicy = () => {
    return (
        <React.Fragment>
            <Header />
            <section>
                <div className="breadcrumbs">
                    <div className="container">
                        <div className="row">
                            <div className="col-md-12 my-auto">
                                <h1>Privacy Policy </h1>
                                <ul className="trail-items">
                                    <li className="trail-item trail-begin">
                                        <Link to="/">
                                            <span itemProp="name">Home</span><i className="bi bi-chevron-double-right"></i>
                                        </Link>
                                    </li>
                                    <li className="trail-item trail-end">
                                        <span itemProp="item"><span itemProp="name">Privacy Policy</span></span>
                                    </li>
                                </ul>
                            </div>
                        </div>
                    </div>
                </div>
            </section>
            <section className="aboutus">
                <div className="container">
                    <div className="row">
                        <div className="aboutus-main">
                            <div className="col-lg-12">
                                <div className="aboutus-subtitle">
                                    <h5>Personal Information</h5>
                                </div>
                                <div className="aboutus-content">
                                    <p>
                                        Taskde Pvt. Ltd. is the licensed owner of the brand Taskde
                                        and the website{" "}
                                        <a className="" href="http://taskde.com/" target="_blank" rel="noopener noreferrer">
                                            taskde.com
                                        </a>{" "}
                                        (”The Site”). We respects your privacy. This Privacy Policy
                                        provides succinct details about how your data is collected
                                        and used by Taskde on the Site. As a visitor to the Site/
                                        Customer, you are advised to please read the Privacy Policy
                                        carefully. By accessing the services provided by the Site
                                        you agree to the collection and use of your data by Taskde
                                        in the manner provided in this Privacy Policy.
                                    </p>
                                </div>
                            </div>
                            <div className="col-lg-12">
                                <div className="aboutus-subtitle">
                                    <h5>What information is, or maybe, collected from you?</h5>
                                </div>
                                <div className="aboutus-content">
                                    <p>
                                        As part of the registration process on the Site, Taskde may
                                        collect the following personally identifiable information
                                        about you: Name including first and last name, email
                                        address, mobile phone number and contact details, Postal
                                        code, Demographic profile (like your age, gender,
                                        occupation, education, address etc.) and information about
                                        the pages on the site you visit/access, the links you click
                                        on the site, the number of times you access the page and any
                                        such browsing information.
                                    </p>
                                </div>
                            </div>
                            <div className="col-lg-12">
                                <div className="aboutus-subtitle">
                                    <h5>How do we collect the Information?</h5>
                                </div>
                                <div className="aboutus-content">
                                    <p>
                                        Taskde will collect personally identifiable information
                                        about you only as part of a voluntary registration process,
                                        on-line survey or any combination thereof. The Site may
                                        contain links to other Web sites. Taskde is not responsible
                                        for the privacy practices of such Web sites which it does
                                        not own, manage or control. The Site and third-party
                                        vendors, including Google, use first-party cookies (such as
                                        the Google Analytics cookie) and third-party cookies (such
                                        as the DoubleClick cookie) together to inform, optimize, and
                                        serve ads based on someone’s past visits to the Site.
                                    </p>
                                </div>
                            </div>
                            <div className="col-lg-12">
                                <div className="aboutus-subtitle">
                                    <h5>How is the information used?</h5>
                                </div>
                                <div className="aboutus-content">
                                    <p>
                                        Taskde will use your personal information to provide
                                        personalized features to you on the Site and to provide for
                                        promotional offers to you through the Site and other
                                        channels. Taskde will also provide this information to its
                                        business associates and partners to get in touch with you
                                        when necessary, to provide the services requested by you.
                                        Taskde will use this information to preserve transaction
                                        history as governed by existing law or policy. Taskde may
                                        also use contact information internally to direct its
                                        efforts for product improvement, to contact you as a survey
                                        respondent, to notify you if you win any contest; and to
                                        send you promotional materials from its contest sponsors or
                                        advertisers. Taskde will also use this information to serve
                                        various promotional and advertising materials to you via
                                        display advertisements through the Google Ad network on
                                        third party websites. You can opt-out of Google Analytics
                                        for Display Advertising and customize Google Display Network
                                        ads using the Ads Preferences Manager. Information about
                                        Customers on an aggregate (excluding any information that
                                        may identify you specifically) covering Customer transaction
                                        data and Customer demographic and location data may be
                                        provided to partners of TaskDe for the purpose of creating
                                        additional features on the website, creating appropriate
                                        merchandising or creating new products and services and
                                        conducting marketing research and statistical analysis of
                                        customer behaviour and transactions.
                                    </p>
                                </div>
                            </div>
                            <div className="col-lg-12">
                                <div className="aboutus-subtitle">
                                    <h5>With whom your information will be shared?</h5>
                                </div>
                                <div className="aboutus-content">
                                    <p>
                                        Taskde will not use your financial information for any
                                        purpose other than to complete a transaction with you.
                                        Taskde does not rent, sell or share your personal
                                        information and will not disclose any of your personally
                                        identifiable information to third parties. In cases where it
                                        has your permission to provide products or services, you’ve
                                        requested and such information is necessary to provide these
                                        products or services with the information may be shared with
                                        Taskde's business associates and partners. Taskde may,
                                        however, share consumer information on an aggregate with its
                                        partners or third parties where it deems necessary. In
                                        addition, Taskde may use this information for promotional
                                        offers, to help investigate, prevent or take action
                                        regarding unlawful and illegal activities, suspected fraud,
                                        potential threat to the safety or security of any person,
                                        violations of the Site’s terms of use or to defend against
                                        legal claims; special circumstances such as compliance with
                                        subpoenas, court orders, requests/order from legal
                                        authorities or law enforcement agencies requiring such
                                        disclosure.
                                    </p>
                                </div>
                            </div>
                            <div className="col-lg-12">
                                <div className="aboutus-subtitle">
                                    <h5>How do we protect your information?</h5>
                                </div>
                                <div className="aboutus-content">
                                    <p>
                                        To protect against the loss, misuse, unauthorised access,
                                        damage and alteration of the information under its control,
                                        Taskde has in place appropriate and reasonable security
                                        measures and safeguards, in compliance with applicable laws.
                                        For example, Taskde servers are accessible only to
                                        authorised personnel and your information is shared with the
                                        authorised personnel on a need to know basis to complete the
                                        transaction and to provide the services requested by you.
                                        Although Taskde will endeavour to safeguard the
                                        confidentiality of your personally identifiable information,
                                        transmissions made by means of the Internet cannot be made
                                        absolutely secure. By using this Site, you agree that Taskde
                                        will have no liability for disclosure of your information
                                        due to errors in transmission or unauthorized acts of third
                                        parties. By using this Site or providing information, you
                                        agree (i) that we can communicate with you electronically
                                        regarding security, privacy, and administrative issues
                                        relating to your use of the Site; and (ii) that we can take
                                        adequate physical, managerial, and technical safeguards to
                                        preserve the integrity and security of your data till the
                                        time you use the Site or the services provided by the Site
                                        (directly or indirectly).
                                    </p>
                                </div>
                            </div>
                            <div className="col-lg-12">
                                <div className="aboutus-subtitle">
                                    <h5>How can you correct inaccuracies in the information?</h5>
                                </div>
                                <div className="aboutus-content">
                                    <p>
                                        To correct or update any information you have provided, the
                                        Site allows you to do it online. In the event of loss of
                                        access details, you can send an email to: care@taskde.com
                                    </p>
                                </div>
                            </div>
                            <div className="col-lg-12">
                                <div className="aboutus-subtitle">
                                    <h5>Policy updates</h5>
                                </div>
                                <div className="aboutus-content">
                                    <p>
                                        Taskde reserves the right to change or update this policy at
                                        any time. Such changes shall be effective immediately upon
                                        posting to the Site.
                                    </p>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </section>
            <Footer />
        </React.Fragment>
    )
}

export default PrivacyPolicy;